export const educationData = [
    {
        id: 1,
        institution: 'Iqra Public School',
        course: 'The Secondary School Certificate (SSC)',
        startYear: '2010',
        endYear: '2019'
    },
    {
        id: 2,
        institution: 'Government Boys Degree College Qasimabad',
        course: 'Computer Science',
        startYear: '2020',
        endYear: '2021'
    },
    {
        id: 3,
        institution: 'University of Sindh',
        course: 'Bachelor of Information Technology (BS-IT)',
        startYear: '2022',
        endYear: 'Present'
    },
]